<div class="upload-wrapper">
  @if (!uploading) {
    <div class="upload-dndarea" wmtDragDrop (filesDropped)="dropFile($event)">
      <span class="upload-dnd-label">Drag & Drop a File here</span>
      <span class="upload-dnd-label small">or</span>
      <div class="upload-chooser">
        <input hidden type="file" class="upload-filechooser" #fileInput id="fileInput" [accept]="accept" (change)="selectFile($event)">
        <label #fileLabel for="fileInput">
          <button pButton class="p-button-secondary" (click)="fileLabel.click()">Select a file from disk</button>
        </label>
      </div>
    </div>
  }
  @if (uploading) {
    <div class="upload-dndarea disabled">
      <span class="upload-dnd-label disabled">Uploading ...</span>
    </div>
  }
  @if (file) {
    <div class="upload-file-entry">
      <div class="name">
        {{file.file.name}}
      </div>
      <div class="size">
        {{(file.file.size / (1024 * 1024)).toFixed(2)}} MB
      </div>
      @if (uploading) {
        <div class="icon passive">
          <fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon>
        </div>
      }
    </div>
  }
  <div class="upload-actions">
    @if (!uploading) {
      <p-button class="action-button" color="accent" label="Upload"  [disabled]="!file" (click)="upload($event)"><fa-icon icon="upload"></fa-icon> </p-button>
    }
    @if (uploading) {
      <p-button class="action-button" color="accent" label="Upload"  [disabled]="true"><fa-icon icon="cog" animation="spin"></fa-icon></p-button>
    }
    <button pButton data-testing-id="cancel-upload-button" class="p-button-text" (click)="cancel()">Cancel</button>
  </div>
</div>
